import { render } from "./vcta.vue?vue&type=template&id=14f60ee3&scoped=true"
import script from "./vcta.vue?vue&type=script&lang=js"
export * from "./vcta.vue?vue&type=script&lang=js"

import "./vcta.vue?vue&type=style&index=0&id=14f60ee3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14f60ee3"

export default script